﻿function generateRandomId() {
    return 'user_' + Math.random().toString(36).substr(2, 11); // You can adjust the length of the random string if needed
}


let randomId = generateRandomId();
var userActions = [];

export function updateArray(item) {
    // Check if the new item is the same as the last item in the array
    if (userActions.length === 0 || userActions[userActions.length - 1] !== item) {
        userActions.push(item);
    }
    //console.log(userActions); // Optionally, you can log the array for debugging
}


//console.log("USER: " + randomId);